"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalStorage = exports.LocalStorage = void 0;
const dataRetrive_1 = require("../dataRetrive");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
class LocalStorage {
    constructor() {
        this.localStorageObj = (0, dataRetrive_1.getTradeDependencyInstance)().getLocalStorage();
    }
    setItem(key, value) {
        this.localStorageObj.setItem(key, value)
            .then();
    }
    getItem(key) {
        return (0, rxjs_1.from)(this.localStorageObj.getItem(key));
    }
    removeItem(key) {
        this.localStorageObj.removeItem(key)
            .then();
    }
    setObjectByKeyString(key, value) {
        if (typeof value !== "boolean" && (!value || typeof value !== "object")) {
            this.removeItem(key);
            return;
        }
        this.setItem(key, JSON.stringify(value));
    }
    getObjectByKeyString(key, defaultValue) {
        return this.getItem(key)
            .pipe((0, operators_1.map)(data => (data === null || data === undefined ? defaultValue : data)))
            .pipe((0, operators_1.catchError)(() => (0, rxjs_1.of)(defaultValue)))
            .pipe((0, operators_1.map)(data => {
            if (data === null) {
                return defaultValue;
            }
            try {
                return JSON.parse(data);
            }
            catch (e) {
                return defaultValue;
            }
        }));
    }
    get(key, defaultValue = null) {
        return this.getItem(key)
            .pipe((0, operators_1.map)(data => (data === null || data === undefined ? defaultValue : data)))
            .pipe((0, operators_1.catchError)(() => (0, rxjs_1.of)(defaultValue)));
    }
    set(key, value) {
        this.setItem(key, value);
    }
    getObject(key, defaultValue) {
        return this.get(key)
            .pipe((0, operators_1.map)(data => {
            if (data === null) {
                return defaultValue;
            }
            try {
                return JSON.parse(data);
            }
            catch (e) {
                return defaultValue;
            }
        }));
    }
    setObject(key, value) {
        if (typeof value !== "boolean" && (!value || typeof value !== "object")) {
            this.removeItem(key);
            return;
        }
        this.set(key, JSON.stringify(value));
    }
}
exports.LocalStorage = LocalStorage;
let gLocalStorage;
function getLocalStorage() {
    if (!gLocalStorage) {
        gLocalStorage = new LocalStorage();
    }
    return gLocalStorage;
}
exports.getLocalStorage = getLocalStorage;
